import swal from 'sweetalert2'
import router from '../packs/router.js'

export default {
  methods: {
    tokenError() {
      swal({
        title: `アクセストークンの期限が切れました。<br>再度ログインしてください。`,
        buttonsStyling: false,
        type: 'warning',
        confirmButtonClass: 'md-button md-success'
      }).then (function () {
        router.push({ path: '/admin/login' })
      })
    },
    dangerNotify(message){
      this.$notify({
        message: message,
        icon: 'add_alarm',
        horizontalAlign: 'left',
        verticalAlign: 'top',
        type: 'danger'
      })
    },
    validateError(text=''){
      swal({
        title: `入力項目に不備があります。<br>再度ご確認お願いいたします。`,
        text: text,
        buttonsStyling: false,
        type: 'warning',
        confirmButtonClass: 'md-button md-success'
      })
    },
    successAndBackPage(message, page=''){
      swal({
        title: message,
        buttonsStyling: false,
        type: 'success',
        confirmButtonClass: 'md-button md-success'
      }).then(response => {
        if (this.newFlag) {
          router.push({ path: page })
        }
      })
    },
    noSearchResults(){
      this.warningMessage(`検索結果がありませんでした`)
    },
    warningMessage(message){
      swal({
        title: message,
        buttonsStyling: false,
        type: 'warning',
        confirmButtonClass: 'md-button md-success'
      })
    }
  }
}
